import { sss } from './testzh'
export default {
  I18n: {
    ...sss,
    仪表盘: '仪表盘',
    工作台: '工作台',
    更新日志: '更新日志',
    配置: '配置',
    用户管理: '用户管理',
    角色管理: '角色管理',
    部门管理: '部门管理',
    菜单管理: '菜单管理',
    组件: '组件',
    角色权限控制: '角色权限控制',
    外链: '外链',
    图标: '图标',
    常规图标: '常规图标',
    小清新图标: '小清新图标',
    多彩图标: '多彩图标',
    图标选择器: '图标选择器',
    表格: '表格',
    综合表格: '综合表格',
    行内编辑表格: '行内编辑表格',
    自定义表格: '自定义表格',
    表单: '表单',
    综合表单: '综合表单',
    分步表单: '分步表单',
    数字自增长: '数字自增长',
    动态标题: '动态标题',
    动态路径参数: '动态路径参数',
    拖拽: '拖拽',
    弹窗拖拽: '弹窗拖拽',
    卡片拖拽: '卡片拖拽',
    流程图拖拽: '流程图拖拽',
    右键菜单: '右键菜单',
    卡片: '卡片',
    多级路由缓存: '多级路由缓存',
    '多级路由1-1': '多级路由1-1',
    '多级路由1-1-1': '多级路由1-1-1',
    加载: '加载',
    视频播放器: '视频播放器',
    编辑器: '编辑器',
    Markdown编辑器: 'Markdown编辑器',
    富文本编辑器: '富文本编辑器',
    上传: '上传',
    错误日志模拟: '错误日志模拟',
    Excel: 'Excel',
    导出Excel: '导出Excel',
    导出选中行Excel: '导出选中行Excel',
    导出合并Excel: '导出合并Excel',
    Css动画: 'Css动画',
    第三方登录: '第三方登录',
    物料源: '物料源',
    物料市场: '物料市场',
    错误页: '错误页',
    403: '403',
    404: '404',
    邮件: '邮件',
    清空消息: '清空消息',
    更多: '更多',
    关闭其他: '关闭其他',
    关闭左侧: '关闭左侧',
    关闭右侧: '关闭右侧',
    关闭全部: '关闭全部',
    退出登录: '退出登录',
    登录: '登录',
    注册: '注册',
    主题配置: '主题配置',
    主题: '主题',
    默认: '默认',
    海洋之心: '海洋之心',
    绿荫草场: '绿荫草场',
    荣耀典藏: '荣耀典藏',
    碰触纯白: '碰触纯白',
    布局: '布局',
    画廊: '画廊',
    纵向: '纵向',
    横向: '横向',
    综合: '综合',
    常规: '常规',
    画廊风格: '画廊风格',
    头部: '头部',
    固定: '固定',
    不固定: '不固定',
    多标签: '多标签',
    国际化: '国际化',
    进度条: '进度条',
    刷新: '刷新',
    通知: '通知',
    全屏: '全屏',
    搜索: '搜索',
    显示: '显示',
    不显示: '不显示',
    随机换肤: '随机换肤',
    拷贝源码: '拷贝源码',
    恢复默认: '恢复默认',
    保存: '保存',
    欢迎来到: '欢迎来到',
    请输入用户名: '请输入用户名',
    请输入密码: '请输入密码',
    用户名不能为空: '用户名不能为空',
    密码不能少于6位: '密码不能少于6位',
    请输入正确的手机号: '请输入正确的手机号',
    请输入手机号: '请输入手机号',
    请输入手机验证码: '请输入手机验证码',
    获取验证码: '获取验证码',
  },
}
